import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Button, Card, CardBody, CardHeader, Col, Row } from "react-bootstrap";
import {
  Elements,
  CardElement,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import {
  createSubscription,
  createPaymentintent,
} from "../../../api/subscription";
import { auth, db } from "../../../firebaseConfig";
import { collection, updateDoc, setDoc, doc } from "firebase/firestore";
import { APIClient } from "../../../api/apiCore";

const CheckoutForm: React.FC = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return <form>dfdfd</form>;
};

const SubscriptionConfirmed = () => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  useEffect(() => {
    const updateUserPayment = async () => {
      // // Payment succeeded, now handle Firestore updates
      // const paymentDate = new Date();
      // const nextPaymentDate = new Date(paymentDate);
      // nextPaymentDate.setMonth(paymentDate.getMonth() + 1); // For monthly subscription

      try {
        // const userId = authUser?.userId;

        // const userRef = doc(db, "users", userId);

        // await setDoc(
        //   userRef,
        //   {
        //     paymentDate: paymentDate.toISOString(),
        //     nextPaymentDate: nextPaymentDate.toISOString(),
        //   },
        //   {
        //     merge: true,
        //   },
        // );

        console.log("Payment and Firestore data saved successfully");
      } catch (error) {
        console.error("Error saving payment data to Firestore: ", error);
      }
    };

    updateUserPayment();
  }, []);
  return (
    <div className="right-panel">
      <div className="sticky-top bg-white shadow-sm w-100 p-3 d-flex justify-content-between align-items-center z-index-100">
        <span className="mb-0 default-text" style={{ fontWeight: "500" }}>
          Subscription
        </span>
      </div>

      <div className="py-3  px-4">
        <div id="breadcrumb" className="d-flex gap-2 my-3">
          <i className="bx bx-home font-size-22"></i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> Subscription</a>
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> Confirm</a>
          </span>
        </div>
        <div className="pt-3">
          <Card>
            <CardBody>Payment has done successfully!</CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionConfirmed;
